var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopyInverted = function SvgCopyInverted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4453 9.00005C11.4453 10.7806 11.4453 11.6716 10.8919 12.2244C10.3391 12.7778 9.44813 12.7778 7.66753 12.7778L5.77865 12.7778C3.99805 12.7778 3.10713 12.7778 2.55431 12.2244C2.00087 11.6716 2.00087 10.7806 2.00087 9.00006L2.00087 5.85191C2.00087 4.07131 2.00087 3.18039 2.55431 2.62757C3.10713 2.07413 3.99805 2.07413 5.77864 2.07413L7.66753 2.07413C9.44813 2.07413 10.3391 2.07413 10.8919 2.62757C11.4453 3.18039 11.4453 4.07131 11.4453 5.85191L11.4453 9.00005Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4431 3.9628C11.9441 3.9628 12.4246 4.16181 12.7788 4.51604C13.133 4.87028 13.332 5.35072 13.332 5.85169L13.332 9.62947C13.332 12.0038 13.332 13.1913 12.5941 13.9286C11.8562 14.6659 10.6693 14.6665 8.29499 14.6665L5.77648 14.6665C5.27551 14.6665 4.79506 14.4675 4.44083 14.1133C4.08659 13.759 3.88759 13.2786 3.88759 12.7776",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
};
export default SvgCopyInverted;